/**
 * 与数据库 tinyint 枚举保持一致
 *
 * customerType: 0公司 1个人
 * paymentType: 0全款
 * orderStatus: 0待审核 1审核失败 2已完成 3已作废
 * screenshotType: 0全款
 * permission: 1管理员 2招商方(代理商)
 */
export const CUSTOMER_TYPE = {
  COMPANY: 0,
  INDIVIDUAL: 1
}

export const PERMISSION = {
  ADMIN: 1,
  AGENT: 2
}

export const PAYMENT_TYPE = {
  FULL: 0
}

export const ORDER_STATUS = {
  PENDING: 0,
  FAIL: 1,
  COMPLETED: 2,
  CANCELLED: 3
}

export const SCREENSHOT_TYPE = {
  FULL: 0
}

export function getCustomerTypeLabel(type) {
  const map = {
    [CUSTOMER_TYPE.COMPANY]: '公司',
    [CUSTOMER_TYPE.INDIVIDUAL]: '个人'
  }
  return map[Number(type)] || '-'
}

export function getPaymentTypeLabel(type) {
  const map = {
    [PAYMENT_TYPE.FULL]: '全款'
  }
  return map[Number(type)] || '-'
}

export function getOrderStatusLabel(status) {
  const map = {
    [ORDER_STATUS.PENDING]: '待审核',
    [ORDER_STATUS.FAIL]: '审核失败',
    [ORDER_STATUS.COMPLETED]: '已完成',
    [ORDER_STATUS.CANCELLED]: '已作废'
  }
  return map[Number(status)] || '未知状态'
}

export function getScreenshotTypeLabel(type) {
  const map = {
    [SCREENSHOT_TYPE.FULL]: '全款'
  }
  return map[Number(type)] || '-'
}

export function getPermissionLabel(permission) {
  const map = {
    [PERMISSION.ADMIN]: '管理员',
    [PERMISSION.AGENT]: '招商方'
  }
  return map[Number(permission)] || '-'
}

/** Element UI Tag type：待审核黄、失败红、完成绿、作废灰 */
export function getOrderStatusTagType(status) {
  const map = {
    [ORDER_STATUS.PENDING]: 'warning',
    [ORDER_STATUS.FAIL]: 'danger',
    [ORDER_STATUS.COMPLETED]: 'success',
    [ORDER_STATUS.CANCELLED]: 'info'
  }
  const key = Number(status)
  return map[key] !== undefined ? map[key] : 'info'
}
